import api from "@/api";
import { ElLoading } from 'element-plus';
import BatterTableDataView from "@/components/BatterTableDataView";
import DialogView from "@/components/DialogView";
export default {
  name: "BannerSettingView",
  components: {
    BatterTableDataView,
    DialogView
  },
  data() {
    return {
      enableMap: {},
      visibleMap: {},
      createBannerVisible: false,
      initQuery: {}
    };
  },
  methods: {
    enableChange(id, val) {
      this.enableMap[id] = val;
      api.updateBannerEnableState(id, val);
    },
    onFetchData(d) {
      for (let itm of d.list) {
        this.enableMap[itm.id] = itm.enable;
        this.visibleMap[itm.id] = itm.visible;
      }
    },
    createBanner(data) {
      let loading = ElLoading.service({
        lock: true,
        text: '解析中...',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      api.createBanner(data).then(() => {
        this.createBannerVisible = false;
        this.initQuery = {
          'fresh': new Date()
        };
        loading.close();
      });
    }
  }
};